import React from 'react';
import { valueForKeyPath as v } from '../utils.jsx';

import SmartTags from './admin/SmartTags.jsx';
import Users from './admin/Users.jsx';

class ContentManagerAdminApiService {
  constructor(api_endpoint, access_token) {
    this.api_endpoint = api_endpoint;
    this.access_token = access_token;
  }

  _fetchRequest(url, method = 'get', data = null, headers = null) {
    const init = {
      method: method,
      headers: {
        Authorization: `Bearer ${this.access_token}`,
        'Content-Type': 'application/json',
      },
    };

    if (data) {
      init.body = JSON.stringify(data);
    }

    const final_url = `${this.api_endpoint}/${url}`;
    return fetch(final_url, init)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .catch(error => {
        return error.response.json().then(error_details => {
          error.details = error_details;
          throw error;
        });
      });
  }

  // smart tags
  loadSmartTags() {
    let url = `admin/contentspace/smart_tags`;
    let method = `get`;
    return this._fetchRequest(url, method);
  }

  saveSmartTags(smartTags) {
    let url = `admin/contentspace/smart_tags`;
    let method = `post`;
    return this._fetchRequest(url, method, smartTags);
  }

  // users
  loadUsers() {
    let url = `admin/contentspaces/users`;
    let method = `get`;
    return this._fetchRequest(url, method);
  }

  addUser(sportnet_id) {
    let url = `admin/contentspaces/users`;
    let method = `post`;
    return this._fetchRequest(url, method, {
      oauth_id: sportnet_id,
    });
  }

  removeUser(user_id) {
    let url = `admin/contentspaces/users/${user_id}`;
    let method = `delete`;
    return this._fetchRequest(url, method);
  }

  addUserAdmin(user_id) {
    let url = `admin/contentspaces/users/${user_id}/admin`;
    let method = 'post';
    return this._fetchRequest(url, method);
  }

  removeUserAdmin(user_id) {
    let url = `admin/contentspaces/users/${user_id}/admin`;
    let method = 'delete';
    return this._fetchRequest(url, method);
  }

  renameUser(user_id, new_display_name) {
    let url = `admin/contentspaces/users/${user_id}/rename`;
    let method = `post`;
    return this._fetchRequest(url, method, {
      name: new_display_name,
    });
  }
}

class ContentManagerAdminContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null,
      smartTags: [],
      users: [],
    };

    this.api_service = new ContentManagerAdminApiService(
      this.props.api_endpoint,
      this.props.access_token,
    );

    // smart tags
    this.loadSmartTags = this.loadSmartTags.bind(this);
    this.saveSmartTags = this.saveSmartTags.bind(this);

    // users
    this.loadUsers = this.loadUsers.bind(this);
  }

  // admin - vseobecne
  adminMenuClick(item) {
    this.setState({ activeItem: item });
  }

  // smart tags
  loadSmartTags() {
    this.api_service
      .loadSmartTags()
      .then(response => {
        this.setState({ smartTags: response.smart_tags });
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  smartTagChange(idx, smartTag) {
    let smartTags = this.state.smartTags;
    smartTags[idx] = smartTag;
    this.setState({ smartTags: smartTags });
  }

  smartTagAdd(smartTag) {
    let smartTags = this.state.smartTags;
    smartTags.push(smartTag);
    this.setState({ smartTags: smartTags });
  }

  smartTagRemove(idx) {
    let smartTags = this.state.smartTags;
    smartTags.splice(idx, 1);
    this.setState({ smartTags: smartTags });
  }

  saveSmartTags() {
    this.api_service
      .saveSmartTags({
        smart_tags: this.state.smartTags,
      })
      .then(response => {
        this.setState({ activeItem: null });
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  // users
  loadUsers() {
    this.api_service
      .loadUsers()
      .then(response => {
        this.setState({ users: response.users });
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  addNewUser(sportnet_id) {
    this.api_service
      .addUser(sportnet_id)
      .then(response => {
        this.loadUsers();
      })
      .catch(error => {
        alert(error.details.description);
      });
  }

  toggleAdmin(user_id, new_status) {
    if (new_status) {
      this.api_service
        .addUserAdmin(user_id)
        .then(response => {
          this.loadUsers();
        })
        .catch(error => {
          console.log(error);
          alert(error.details.description);
        });
    } else {
      this.api_service
        .removeUserAdmin(user_id)
        .then(response => {
          this.loadUsers();
        })
        .catch(error => {
          console.log(error);
          alert(error.details.description);
        });
    }
  }

  removeUser(user_id) {
    this.api_service
      .removeUser(user_id)
      .then(response => {
        this.loadUsers();
      })
      .catch(error => {
        console.log(error);
        alert(error.details.description);
      });
  }

  renameUser(user_id, new_display_name) {
    this.api_service
      .renameUser(user_id, new_display_name)
      .then(response => {
        this.loadUsers();
      })
      .catch(error => {
        console.log(error);
        alert(error.details.description);
      });
  }

  render() {
    let content;

    if (this.state.activeItem === 'smarttags') {
      content = (
        <SmartTags
          smartTags={this.state.smartTags}
          loadSmartTags={this.loadSmartTags}
          smartTagChange={this.smartTagChange.bind(this)}
          smartTagAdd={this.smartTagAdd.bind(this)}
          smartTagRemove={this.smartTagRemove.bind(this)}
          save={this.saveSmartTags}
        />
      );
    } else if (this.state.activeItem === 'users') {
      content = (
        <Users
          users={this.state.users}
          loadUsers={this.loadUsers}
          user={this.props.user}
          addNewUser={this.addNewUser.bind(this)}
          toggleAdmin={this.toggleAdmin.bind(this)}
          removeUser={this.removeUser.bind(this)}
          renameUser={this.renameUser.bind(this)}
        />
      );
    } else {
      content = (
        <div>
          <p>Poračujte výberom časti, ktorú chcete upravovať.</p>
        </div>
      );
    }

    return (
      <div>
        <div className="panel panel-primary">
          <div className="panel-heading clearfix">
            <span key="context-text" className="panel-title">
              <span>Spravujete contentspace: </span>
              <strong>{this.props.contentspace_info.name}</strong>
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="panel panel-default">
              <div className="panel-heading">
                <strong>Administrácia</strong>
              </div>
              <div className="panel-body">
                <ul className="menu-list">
                  <li>
                    <a
                      className="list-item-ico"
                      href="javascript:void(0);"
                      onClick={this.adminMenuClick.bind(this, 'smarttags')}
                    >
                      <span className="fa fa-tags" />
                    </a>
                    &nbsp;
                    <a
                      href="javascript:void(0);"
                      onClick={this.adminMenuClick.bind(this, 'smarttags')}
                    >
                      {this.state.activeItem === 'smarttags' ? (
                        <strong>Povolené typy Smart tagov</strong>
                      ) : (
                        'Povolené typy Smart tagov'
                      )}
                    </a>
                  </li>
                  <li>
                    <a
                      className="list-item-ico"
                      href="javascript:void(0);"
                      onClick={this.adminMenuClick.bind(this, 'users')}
                    >
                      <span className="fa fa-user" />
                    </a>
                    &nbsp;
                    <a
                      href="javascript:void(0);"
                      onClick={this.adminMenuClick.bind(this, 'users')}
                    >
                      {this.state.activeItem === 'users' ? (
                        <strong>Používatelia</strong>
                      ) : (
                        'Používatelia'
                      )}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-9">{content}</div>
        </div>
      </div>
    );
  }
}

ContentManagerAdminContainer.defaultProps = {
  access_token: null,
  api_endpoint: '../api',
};

export default ContentManagerAdminContainer;



// WEBPACK FOOTER //
// ./src/js/app/ContentManagerAdminContainer.jsx